import React from "react";
import {
  Box,
  Typography,
  Divider,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  useMediaQuery,
  Theme,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const EndpointGenerateForm = (props) => {
  const { onClick } = props;
  const [expandedProvincias, setExpandedProvincias] = React.useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const renderTableRow = (name, entity, required, description, example) => (
    <TableRow sx={{ verticalAlign: "top" }}>
      <TableCell
        sx={{
          fontFamily: "Courier New,Courier,monospace!important",
          fontSize: { xs: "0.8rem", sm: "0.94rem" },
          fontWeight: "600",
          padding: { xs: 1, sm: 2 },
        }}
      >
        {name}
      </TableCell>
      {!isSmallScreen && (
        <>
          <TableCell
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: { xs: "0.8rem", sm: "0.94rem" },
              padding: { xs: 1, sm: 2 },
            }}
          >
            {entity}
          </TableCell>
          <TableCell
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: { xs: "0.8rem", sm: "0.94rem" },
              padding: { xs: 1, sm: 2 },
            }}
          >
            {required}
          </TableCell>
        </>
      )}
      <TableCell
        sx={{
          fontFamily: "Courier New,Courier,monospace!important",
          fontSize: { xs: "0.8rem", sm: "0.94rem" },
          padding: { xs: 1, sm: 2 },
        }}
      >
        {isSmallScreen && (
          <>
            <strong>Entidad:</strong> {entity}
            <br />
            <strong>Requerido:</strong> {required}
            <br />
          </>
        )}
        {description}
      </TableCell>
      <TableCell
        sx={{
          fontFamily: "Courier New,Courier,monospace!important",
          fontSize: { xs: "0.8rem", sm: "0.94rem" },
          padding: { xs: 1, sm: 2 },
        }}
      >
        {example}
      </TableCell>
    </TableRow>
  );

  return (
    <Box {...props}>
      <Box sx={{ mt: 4 }}>
        <Typography
          sx={{
            fontSize: "1.10rem",
            color: "primary.dark",
            fontWeight: "700",
          }}
        >
          Descripción
        </Typography>
        <Typography
          sx={{
            fontSize: "1.00rem",
            color: "primary.dark",
            my: 1,
          }}
        >
          Api para generar el link del formulario de prescripción de receta. En
          el body del endpoint se especifica los campos del médico que prescribe
          y del paciente para el qué se genera la receta médica.
        </Typography>
      </Box>
      <Box sx={{ my: 4 }}>
        <Typography
          sx={{
            fontSize: "1.10rem",
            color: "primary.dark",
            fontWeight: "700",
          }}
        >
          Resource URL
        </Typography>
        <Typography
          sx={{
            fontSize: "1.00rem",
            color: "#067acc",
          }}
        >
          GenerateForm/Generate
        </Typography>
      </Box>
      <Box sx={{ my: 4 }}>
        <Typography
          sx={{
            fontSize: "1.10rem",
            color: "primary.dark",
            fontWeight: "700",
          }}
        >
          Resource Information
        </Typography>
        <Box sx={{ mx: 1, my: 2 }}>
          <Typography
            sx={{
              fontSize: "1.00rem",
              color: "primary.dark",
            }}
          >
            Formato respuesta: <span style={{ fontWeight: "bold" }}>JSON</span>
          </Typography>
        </Box>
        <Box sx={{ mx: 1, my: 2 }}>
          <Typography
            sx={{
              fontSize: "1.00rem",
              color: "primary.dark",
            }}
          >
            ¿Requiere autenticación?:{" "}
            <span style={{ fontWeight: "bold" }}>Sí.</span>
          </Typography>
        </Box>
      </Box>
      <Box sx={{ my: 4 }}>
        <Typography
          sx={{
            fontSize: "1.10rem",
            color: "primary.dark",
            fontWeight: "700",
          }}
        >
          Autenticación
        </Typography>
        <Typography
          sx={{
            fontSize: "0.92rem",
            color: "primary.dark",
          }}
        >
          Para la autenticación de la api, se debe previamente generar un token
          de sesión con el API endpoint Login. Cada aplicación debe generar su
          propia autenticación para que la prescripción sea bajo esas
          condiciones.
        </Typography>
        <Box
          sx={{
            p: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: "0.82rem",
              color: "primary.dark",
              fontWeight: "bold",
            }}
          >
            Ejemplo:
          </Typography>
          <Typography
            sx={{
              fontSize: "0.92rem",
              color: "primary.dark",
              fontFamily: "Courier New,Courier,monospace!important",
            }}
          >
            -H "Authorization: Bearer 4eC39HqLyjWDarjtT1zdp7dc"
          </Typography>
        </Box>
      </Box>
      <Box sx={{ my: 4 }}>
        <Typography
          sx={{
            fontSize: "1.10rem",
            color: "primary.dark",
            fontWeight: "700",
          }}
        >
          Parámetros
        </Typography>
        <Typography
          sx={{
            fontSize: "0.92rem",
            color: "primary.dark",
          }}
        >
          No se requieren parámetros
        </Typography>
      </Box>
      <Box sx={{ my: 4 }}>
        <Typography
          sx={{
            fontSize: "1.10rem",
            color: "primary.dark",
            fontWeight: "700",
          }}
        >
          Request Body
        </Typography>
        <Box sx={{ my: 2, p: 2, background: "#f3f7fa", borderRadius: "4px" }}>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
            }}
          >
            {"{"}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "urlCallback": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "paciente": {"{"}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "nombre": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "apellido": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "tipoDocumento": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "nroDocumento": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "cuil": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "sexo": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "email": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "fechaNacimiento": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "numeroAfiliado": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "numeroFinanciador": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "plan": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            {"}"},
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "medico": {"{"}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "nombre": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "apellido": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "email": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "tipoDocumento": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "nroDocumento": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "cuil": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "tipoMatricula": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "numeroMatricula": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "provinciaMatricula": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "telefono": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "fechaNacimiento": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "sexo": "string",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "especialidad": "string"
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "firma": "string"
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            {"}"},
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "direccionConsultorio": "string"
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
            }}
          >
            {"}"}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ my: 4 }}>
        <Typography
          sx={{
            fontSize: { xs: "1rem", sm: "1.10rem" },
            color: "primary.dark",
            fontWeight: "700",
          }}
        >
          Request body information
        </Typography>
        <Box sx={{ my: 2, overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow sx={{ verticalAlign: "top" }}>
                <TableCell>Nombre</TableCell>
                {!isSmallScreen && (
                  <>
                    <TableCell>Entidad</TableCell>
                    <TableCell>Requerido</TableCell>
                  </>
                )}
                <TableCell>Descripción</TableCell>
                <TableCell>Ejemplo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {renderTableRow(
                "urlCallback",
                "",
                "Opcional",
                "URL de callback al ejecutar la acción de retorno desde el formulario.",
                ""
              )}
              {renderTableRow(
                "direccionConsultorio",
                "",
                "Opcional",
                "Se corresponde con un texto libre que determina la dirección física del consultorio donde el médico esta prescribiendo.",
                "Pasteur 234, Clinica Del Sur"
              )}
              {renderTableRow(
                "nombre",
                "Paciente",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                "Tomás"
              )}
              {renderTableRow(
                "apellido",
                "Paciente",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                "Manchini"
              )}
              {renderTableRow(
                "tipoDocumento",
                "Paciente",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                "DNI"
              )}
              {renderTableRow(
                "nroDocumento",
                "Paciente",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                "33597809"
              )}
              {renderTableRow(
                "CUIL",
                "Paciente",
                "Opcional",
                "Este campo no es configurable. Es OPCIONAL.",
                "20333333331"
              )}
              {renderTableRow(
                "sexo",
                "Paciente",
                "Opcional (configurable)",
                "Este campo es configurable. Es OPCIONAL siempre y cuando no se haya configurado como OBLIGATORIO en la configuración de la aplicación.",
                "M, F o X"
              )}
              {renderTableRow(
                "email",
                "Paciente",
                "Opcional (configurable)",
                "Este campo es configurable. Es OPCIONAL siempre y cuando no se haya configurado como OBLIGATORIO en la configuración de la aplicación.",
                ""
              )}
              {renderTableRow(
                "fechaNacimiento",
                "Paciente",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                "Formato: YYYY-MM-DD Ejemplo: 2023-01-28"
              )}
              {renderTableRow(
                "numeroAfiliado",
                "Paciente",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                ""
              )}
              {renderTableRow(
                "numeroFinanciador",
                "Paciente",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                ""
              )}
              {renderTableRow(
                "plan",
                "Paciente",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                ""
              )}
              {renderTableRow(
                "nombre",
                "Medico",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                ""
              )}
              {renderTableRow(
                "apellido",
                "Medico",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                ""
              )}
              {renderTableRow(
                "email",
                "Medico",
                "Opcional (configurable)",
                "Este campo es configurable. Es OPCIONAL siempre y cuando no se haya configurado como OBLIGATORIO en la configuración de la aplicación.",
                ""
              )}
              {renderTableRow(
                "tipoDocumento",
                "Medico",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                "DNI"
              )}
              {renderTableRow(
                "nroDocumento",
                "Medico",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                "33597809"
              )}
              {renderTableRow(
                "CUIL",
                "Medico",
                "Opcional",
                "Este campo no es configurable. Es OPCIONAL.",
                "20333333331"
              )}
              {renderTableRow(
                "tipoMatricula",
                "Medico",
                "Obligatorio",
                "Este campo es obligatorio siempre. Se corresponde con el tipo de matrícula del médico. MN: Matrícula nacional, MP: Matrícula provincial. Por default es obligatorio, no se puede configurar como opcional.",
                "MN, MP"
              )}
              {renderTableRow(
                "numeroMatricula",
                "Medico",
                "Obligatorio",
                "Este campo es obligatorio siempre. Se corresponde con el número de matrícula del médico. Por default es obligatorio, no se puede configurar como opcional.",
                ""
              )}
              {renderTableRow(
                "provinciaMatricula",
                "Medico",
                "Obligatorio",
                "Este campo es obligatorio siempre y cuando el tipoMatricula sea provincial (MP).",
                <Accordion
                  expanded={expandedProvincias}
                  onChange={() => setExpandedProvincias(!expandedProvincias)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel12-header"
                    sx={{
                      background: "#D4d4d4",
                      borderRadius: 1,
                    }}
                  >
                    <Typography sx={{ fontWeight: "bold" }}>
                      Listado de provincias
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: "10px 30px 30px 30px" }}>
                    <Typography component="div">
                      {[
                        "ENTRE RIOS",
                        "SANTIAGO DEL ESTERO",
                        "LA RIOJA",
                        "BUENOS AIRES",
                        "CATAMARCA",
                        "SANTA FE",
                        "SAN LUIS",
                        "MENDOZA",
                        "CORRIENTES",
                        "SANTA CRUZ",
                        "NEUQUEN",
                        "FORMOSA",
                        "SAN JUAN",
                        "SALTA",
                        "CIUDAD AUTONOMA DE BS.AS.",
                        "RIO NEGRO",
                        "CHACO",
                        "LA PAMPA",
                        "TIERRA DEL FUEGO",
                        "JUJUY",
                        "MISIONES",
                        "CORDOBA",
                        "TUCUMAN",
                        "CHUBUT",
                      ].map((provincia, index) => (
                        <p key={index}>{provincia}</p>
                      ))}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              )}
              {renderTableRow(
                "telefono",
                "Medico",
                "Opcional (configurable)",
                "Este campo es configurable. Es OPCIONAL siempre y cuando no se haya configurado como OBLIGATORIO en la configuración de la aplicación.",
                "1151420490"
              )}
              {renderTableRow(
                "fechaNacimiento",
                "Medico",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                "Formato: YYYY-MM-DD Ejemplo: 2023-01-28"
              )}
              {renderTableRow(
                "sexo",
                "Medico",
                "Opcional (configurable)",
                "Este campo es configurable. Es OPCIONAL siempre y cuando no se haya configurado como OBLIGATORIO en la configuración de la aplicación.",
                "M, F o X"
              )}
              {renderTableRow(
                "especialidad",
                "Medico",
                "Obligatorio",
                "Este campo es obligatorio siempre.",
                "CARDIOLOGIA"
              )}
              {renderTableRow(
                "firma",
                "Medico",
                "Opcional",
                "Este campo no es configurable. Es OPCIONAL. En este campo se debe enviar el valor en formato base64 de la imagen de la firma del médico.",
                "https://medicos/5f30cdc2ab6efoto3.png"
              )}
            </TableBody>
          </Table>
        </Box>
      </Box>
      <Box sx={{ my: 4 }}>
        <Typography
          sx={{
            fontSize: "1.10rem",
            color: "primary.dark",
            fontWeight: "700",
          }}
        >
          Request example
        </Typography>
        <Box sx={{ my: 2, p: 2, background: "#f3f7fa", borderRadius: "4px" }}>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
            }}
          >
            {"{"}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "urlCallback": "",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "paciente": {"{"}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "numeroAfiliado": "04986101008",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "numeroFinanciador": "209"
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            {"}"},
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "medico": {"{"}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "tipoMatricula": "MN",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 6,
            }}
          >
            "numeroMatricula": "21113333"
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            {"}"},
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "direccionConsultorio": ""
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
            }}
          >
            {"}"}
          </Typography>
        </Box>
        <Divider sx={{ my: 2 }} />
        <Typography
          sx={{
            fontFamily: "Courier New,Courier,monospace!important",
            fontSize: "0.94rem",
            color: "primary.dark",
          }}
        >
          <span style={{ fontWeight: "bold" }}>Observación:</span> En el request
          de ejemplo, para el paciente se configuró como obligatorio los campos
          numeroAfiliado y numeroFinanciador.
        </Typography>
      </Box>
      <Box sx={{ my: 4 }}>
        <Typography
          sx={{
            fontSize: "1.10rem",
            color: "primary.dark",
            fontWeight: "700",
          }}
        >
          Response examples
        </Typography>
        <Box sx={{ my: 2, p: 2, background: "#F7FAEC", borderRadius: "4px" }}>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.98rem",
              fontWeight: "bold",
              color: "primary.dark",
            }}
          >
            Code: 401 -{" "}
            <span style={{ fontWeight: "Bold" }}>Status: Unauthorized</span>
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
            }}
          >
            No está autorizado para generar el link del formulario de
            prescripción. Revisar la generación del token.
          </Typography>
        </Box>
        <Box
          sx={{
            my: 2,
            p: 2,
            background: "#F7FAEC",
            borderRadius: "4px",
            overflowX: "auto",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Courier New, Courier, monospace!important",
              fontSize: { sm: "0.95rem", md: "0.94rem" },
              fontWeight: "bold",
              color: "primary.dark",
              wordWrap: "break-word",
            }}
          >
            Code: 200 - <span style={{ fontWeight: "bold" }}>Status: OK</span>
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Typography
            sx={{
              fontFamily: "Courier New, Courier, monospace!important",
              fontSize: { sm: "0.95rem", md: "0.94rem" },
              color: "primary.dark",
            }}
          >
            {"{"}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New, Courier, monospace!important",
              fontSize: { sm: "0.9rem", md: "0.94rem" },
              color: "primary.dark",
              pl: { xs: 2, sm: 3 },
            }}
          >
            "result": {"{"}
          </Typography>
          <Box>
            <Typography
              sx={{
                fontFamily: "Courier New, Courier, monospace!important",
                fontSize: { sm: "0.95rem", md: "0.94rem" },
                color: "primary.dark",
                pl: { xs: 4, sm: 6 },
                wordBreak: "break-all", // Manejo de URLs largas
              }}
            >
              "url":"
              {process.env.REACT_APP_PUBLIC_URL}
              /formulario/b97ab5fc-226c-49ec-9fda-537897c49431",
            </Typography>
          </Box>
          <Typography
            sx={{
              fontFamily: "Courier New, Courier, monospace!important",
              fontSize: { sm: "0.95rem", md: "0.94rem" },
              color: "primary.dark",
              pl: { xs: 2, sm: 3 },
            }}
          >
            {"}"},
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New, Courier, monospace!important",
              fontSize: { sm: "0.95rem", md: "0.94rem" },
              color: "primary.dark",
              pl: { xs: 2, sm: 3 },
            }}
          >
            "status": "Ok",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New, Courier, monospace!important",
              fontSize: { sm: "0.95rem", md: "0.94rem" },
              color: "primary.dark",
              pl: { xs: 2, sm: 3 },
            }}
          >
            "successMessage": "",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New, Courier, monospace!important",
              fontSize: { sm: "0.95rem", md: "0.94rem" },
              color: "primary.dark",
              pl: { xs: 2, sm: 3 },
            }}
          >
            "errors": {"[]"},
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New, Courier, monospace!important",
              fontSize: { sm: "0.95rem", md: "0.94rem" },
              color: "primary.dark",
              pl: { xs: 2, sm: 3 },
            }}
          >
            "validationErrors": {"[]"}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New, Courier, monospace!important",
              fontSize: { sm: "0.95rem", md: "0.94rem" },
              color: "primary.dark",
            }}
          >
            {"}"}
          </Typography>
        </Box>

        <Box sx={{ my: 2, p: 2, background: "#FEE9E9", borderRadius: "4px" }}>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.98rem",
              fontWeight: "700",
              color: "primary.dark",
            }}
          >
            Code: 200 -{" "}
            <span style={{ fontWeight: "Bold" }}>Status: Error</span>
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
            }}
          >
            {"{"}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "result": null,
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "status": "Error",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "successMessage": "",
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "Errors": {"["}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 8,
            }}
          >
            "El financiador especificado no corresponde con la configuración de
            la aplicación."
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            {"],"}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
              pl: 3,
            }}
          >
            "validationErrors": {"[]"}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Courier New,Courier,monospace!important",
              fontSize: "0.94rem",
              color: "primary.dark",
            }}
          >
            {"}"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}